import React from 'react';
import PropTypes from 'prop-types';

import { graphql, compose, gql } from 'react-apollo';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BannerCaption.css';
import {
  Grid,
  Row,
  Col,
  Button
} from 'react-bootstrap';
import cx from 'classnames';
import bt from '../../commonStyle.css';
import Loader from '../../Loader';

// Translation
import { FormattedMessage } from 'react-intl';

// Locale
import messages from '../../../locale/messages';

// History
import history from '../../../core/history';
class BannerCaption extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getBanner: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        content: PropTypes.string,
      }),
    }),
  };

  handleClick() {
    history.push('/findoutmore');
  }

  render() {
    const { getBannerData } = this.props;
    let data, loading, title, content;
    data = getBannerData.getBanner;
    loading = getBannerData.loading;
    
    if(data) {
      title = getBannerData.getBanner.title;
      content = getBannerData.getBanner.content
    }

    if(!data) return <div />

    if(loading) return <Loader type={"text"} />

      return (
        <Grid fluid>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} className={cx(s.bannerCaptionContainer)}>
              <div className={s.container}>
                <h1 className={cx(s.noMargin, s.bannerCaptionText)}>
                  {title}
                </h1>
                <p className={cx(s.bannerCaptionDescriptionText, s.space5)}>
                  {content}
                </p> 
                <Button className={cx(bt.btnPrimary, bt.btnShadow, s.spaceTop5)} onClick={this.handleClick}>
                  <FormattedMessage {...messages.findOutMore} />
                </Button>
              </div>
            </Col>
          </Row>
        </Grid>
      );
    }
}

export default compose(
  withStyles(s, bt),
  graphql(gql`
  query getBanner {
    getBanner {
      id
      title
      content
    }
  }
`, {
    name: 'getBannerData',
    options: {
      ssr: true
    }
  }),
)(BannerCaption);


// WEBPACK FOOTER //
// src/components/Home/BannerCaption/BannerCaption.js